import React, { useState, useEffect, useContext } from 'react'
import './trending.css'
// import Price from './Coins'

function Trending() {

    // const btcprice = useContext(Price);
    // console.log(btcprice)

    const [trending, setTrending] = useState([]);

    const fetchTrending = async () => {
        const url = `https://api.coingecko.com/api/v3/search/trending`;
        let data = await fetch(url);
        let parsedData = await data.json();
        // console.log(parsedData);
        setTrending(parsedData.coins);
        console.log(trending);
    }

    useEffect(() => {
        fetchTrending();
    }, [])


    return (
        <div>
            <div className="row trending_row">
                <h1>Top 7 Trending Coins on CoinGecko</h1>
                {trending.map((element) => {
                    return (<>
                        <div className="card trending_coin" key={element.id}>
                            <img src={element.item.large} className="card-img-top trending_img" alt={element.item.name} />
                            <div className="card-body trending_card_body">
                                <p className="card-text">{element.item.name}</p>
                                <p className="card-text">{element.item.price_btc} BTC</p>

                            </div>
                        </div>
                    </>)
                })}
            </div>


            {/* 
            <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {trending.map((element) => {
                        return (<>

                            <div className="carousel-item active">
                                <div className="card trending_coin" key={element.id}>
                                    <img src={element.item.large} className="card-img-top trending_img" alt={element.item.name} />
                                    <div className="card-body trending_card_body">
                                        <p className="card-text">{element.item.name}</p>
                                        <p className="card-text">{(element.item.price_btc)}</p>

                                    </div>
                                </div>
                            </div>

                        </>)
                    })}

                </div>

            </div> */}



        </div>
    )
}

export default Trending